import { throwError as observableThrowError, Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StorageSessionService } from '../../storage/services/storage.session.service';
import { HttpClient, HttpResponseBase, HttpRequest } from '@angular/common/http';

@Injectable()
export class HttpService {
	defaultOptionsArgs: HttpRequest<object>;

	constructor(
		protected http: HttpClient,
		protected storageSessionService: StorageSessionService,
		protected router: Router
	) {}

	post(servicePath: string, model: any, options?: any) {
		options = options ? options : this.defaultOptionsArgs;
		return this.http.post(servicePath, model, options);
	}

	get(servicePath: string, data?: any, options?: any) {
		options = options ? options : this.defaultOptionsArgs;
		return this.http.get(servicePath, options);
	}

	handleError(error: HttpResponseBase) {
		console.log(error);
		return of(error);
	}
}
